/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WsSubscribe
 */
export interface WsSubscribe {
    /**
     * Type of the message
     * @type {string}
     * @memberof WsSubscribe
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WsSubscribe
     */
    address: string;
}

/**
 * Check if a given object implements the WsSubscribe interface.
 */
export function instanceOfWsSubscribe(value: object): value is WsSubscribe {
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function WsSubscribeFromJSON(json: any): WsSubscribe {
    return WsSubscribeFromJSONTyped(json, false);
}

export function WsSubscribeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WsSubscribe {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'address': json['address'],
    };
}

export function WsSubscribeToJSON(json: any): WsSubscribe {
    return WsSubscribeToJSONTyped(json, false);
}

export function WsSubscribeToJSONTyped(value?: WsSubscribe | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'address': value['address'],
    };
}

